import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { AppRoot } from "./AppRoot";
// Pretendard 가변 폰트(unicode-range dynamic subset). :root의 font-family가 참조한다.
// c6-frontend-design 컴포넌트는 font-family: inherit 이다. 그래서 호스트 폰트만 바꾸면 함께 바뀐다.
import "pretendard/dist/web/variable/pretendardvariable-dynamic-subset.css";
import "./styles.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element #root was not found.");
}

createRoot(root).render(
  <StrictMode>
    <AppRoot />
  </StrictMode>,
);
